import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ANALYTICS_SOURCE } from '../constants/snippetAnalytics.ts';
import { setOnFetchComplete, type FetchPerformanceMetrics } from '../store/actions/fetchActions.ts';

/**
 * Registers an analytics callback for snippet fetch performance metrics.
 *
 * Fires an operational event after each successful fetch with:
 * snippetCount, userScopeCount, globalScopeCount, payloadSizeBytes, durationMs.
 *
 * Call this from a component that is mounted before fetchSnippets() runs
 * (e.g. SnippetsProvider).
 */
export const useSnippetsFetchAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		setOnFetchComplete((metrics: FetchPerformanceMetrics) => {
			createAnalyticsEvent({
				type: 'sendOperationalEvent',
				data: {
					source: ANALYTICS_SOURCE,
					action: 'fetched',
					actionSubject: 'snippets',
					type: 'operational',
					attributes: metrics,
				},
			}).fire();
		});

		return () => setOnFetchComplete(null);
	}, [createAnalyticsEvent]);
};
